import { API } from "aws-amplify";

async function updateSite(site: Site): Promise<Site> {
  try {
    const path: string = `/sites/${site.companyId}/${site.siteId}`;

    const tempSite: any = {
      ...site
    }
    delete tempSite.companyId
    delete tempSite.siteId
    
    const options = {
      body: tempSite
    };

    const data = await API.put(
      'api-service',
      path,
      options
    );

    
    return data.data as Site;
  } catch (error: any) {
    throw error;
  }
}

export default updateSite;
